export const enum DepositLimitType {
	ResponsibleGaming = "ResponsibleGaming",
	TemporaryAccountLifetimeLimit = "TemporaryAccountLifetimeLimit",
	PureDepositLimit = "PureDepositLimit",
}

export const enum DepositLimitPeriodType {
	NoLimit = "NoLimit",
	Daily = "Daily",
	Weekly = "Weekly",
	Monthly = "Monthly",
	LifeTime = "LifeTime",
}

export const enum DepositLimitMessageCodes {
	CooloffPeriod = "E_COOLOFFPERIOD",
	CooloffPeriodInvalidInterval = "E_COOLOFFPERIOD_INVALIDINTERVAL",
	DuplicatePureDepositLimit = "E_DEPOSITLIMIT_DUPLICATEPUREDEPOSITLIMIT",
	Error = "E_DEPOSITLIMIT",
	InvalidPeriod = "E_DEPOSITLIMIT_INVALIDPERIOD",
	InvalidType = "E_DEPOSITLIMIT_INVALIDTYPE",
	LimitWithTypeNotFound = "E_DEPOSITLIMIT_LIMITWITHTYPENOTFOUND",
	UpdateSuccess = "M_DEPOSIT_LIMIT_UPDATE_SUCCESS",
	DeleteSuccess = "M_DEPOSIT_LIMIT_DELETE_SUCCESS",
	AcceptUnconfirmedSuccess = "M_DEPOSIT_LIMIT_ACCEPT_UNCONFIRMED_SUCCESS",
	DeclineUnconfirmedSuccess = "M_DEPOSIT_LIMIT_DECLINE_UNCONFIRMED_SUCCESS",
}

export enum DepositLimitPeriod {
	NoLimit = 0,
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
	LifeTime = 1000000,
}

export interface DepositLimitState {
	depositLimits?: DepositLimits;
	depositLimitsUnconfirmed?: DepositLimits;
}

export interface DepositLimitConfig {
	endpoints?: {
		depositLimit?: string;
	};
	isReconfirmationRequired?: boolean;
}

export interface DepositLimits extends Record<string, DepositLimit | undefined> {
	responsibleGaming: DepositLimit | undefined;
	temporaryAccountLifetimeLimit?: DepositLimit;
	pureDepositLimit?: DepositLimit;
}

export interface DepositLimit {
	amount: number;
	period: DepositLimitPeriodType;
	startDate: string;
	endDate?: string;
	createdDate: string;
	queuedDepositLimit?: DepositLimit;
	depositLimitType: DepositLimitType;
	depositLimitId: number;
}

export interface DepositLimitParams {
	limit: number;
	depositLimitPeriod: DepositLimitPeriod;
	depositLimitType: DepositLimitType;
}

export interface DepositLimitUnconfirmedParams {
	depositLimitId?: number;
	depositLimitType?: DepositLimitType;
}
